import type { SelectProps } from 'core/components/ui';
import { Select } from 'core/components/ui';

export function RolesSelect(props: SelectProps) {
  return <Select className="w-100" {...props} />;
}
